export const closeIcon = `<svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle opacity="0.2" cx="15.5" cy="15.5" r="15.5" fill="#23AFCD"/>
<path d="M19.2885 10.9246L16.0189 14.1942L12.7493 10.9246L11.9246 11.7493L15.1942 15.0189L11.9246 18.2885L12.7493 19.1132L16.0189 15.8436L19.2885 19.1132L20.1132 18.2885L16.8436 15.0189L20.1132 11.7493L19.2885 10.9246Z" fill="white"/>
</svg>`;
